/* 🤖 this file was generated by script */
export const wsolidiconFaceFrown = {
  name: 'face_frown',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22M7.5 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m6 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-6.1 7.8a1 1 0 0 0 1.4-.2l.2-.22q.21-.24.65-.57A4 4 0 0 1 12 15a4 4 0 0 1 2.35.8 5 5 0 0 1 .85.8 1 1 0 0 0 1.6-1.2l-.1-.13-.25-.27a7 7 0 0 0-.92-.8c-.8-.59-2-1.2-3.53-1.2s-2.73.61-3.53 1.2a7 7 0 0 0-1.27 1.2 1 1 0 0 0 .2 1.4" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
